module.exports = __webpack_public_path__ + "static/media/signup_login.0f3c7a0d.svg";